export default __webpack_public_path__ + "static/media/Glaive of Red Ruin.82208ea3.jpg";